import React from "react";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link as RouterLink } from "react-router-dom";

const LinkRouter = (props) => <Link {...props} component={RouterLink} />;

const BreadcrumbBack = ({ path }) => {
    const refererPath = decodeURIComponent(path);

    return (
        <Breadcrumbs aria-label="breadcrumb">
            <LinkRouter underline="hover" color="inherit" to={refererPath}>
                Back
            </LinkRouter>
        </Breadcrumbs>
    );
};

export default BreadcrumbBack;
